import { fromJS, List } from 'immutable';
import ld from 'lodash';
import { SET_FIELD_VALUE, RESET_FIELD_VALUE } from '../../app.reducer.jsx';
import { CHANGE_PERSONS_ARRAY } from '../persons.array/reducer.jsx';
//import { reducerPipe } from '../../common/utils.jsx';

export const IDENTICAL = 1;
export const FRATERNAL = 2;

export const PROBAND_INDEX = '0';

export const MULTIBIRTH_PATH = 'multibirth';
export const PERSONS_PATH = 'persons';
export const IDENTICAL_GROUPS_PATH = 'identicalGroups';
export const DATA_PATH = 'data';

export const TWIN_FIELD_NAME = 'isTwin';
export const GENDER_FIELD_NAME = 'gender';
export const ADOPTED_FIELD_NAME = 'isAdopted';
export const DATE_OF_BIRTH_FIELD_NAME = 'dob';
export const TWIN_TYPE_FIELD_NAME = '__twinType';
export const PERSON_BIRTH_GROUP_FIELD_NAME = '__personInBirthGroup';

export const YES_VALUE = 'yes';
export const NO_VALUE = 'no';

const SINGLE_SPACE = ' ';

function _extractMultibirthData(state, action) {
    if (PROBAND_INDEX === action.name) {
        return { srcPersonId: PROBAND_INDEX };
    }
    const path = action.root.split(SINGLE_SPACE);
    const srcPersonId = path.pop();
    path.pop(); //pop 'data'
    path.push(MULTIBIRTH_PATH);
    const multibirths = state.getIn(path, new List());
    return { path, srcPersonId, multibirths };
}

function __makeMatchPersonId(personId) { return (id) =>  id === personId; }
function __makeNotMatchPersonId(personId) { return (id) =>  id !== personId; }
function __makeIsIndexOf(searchForIndex) { return (arrayInstance) => -1 !== arrayInstance.indexOf(searchForIndex); }
//function __makeIsNotIndexOf(searchForIndex){ return (arrayInstance) => -1 === arrayInstance.indexOf(searchForIndex); }
function _notANull(value) { return null !== value; }

function getDefaultMultibirth(/*arguments - persons Id's*/) { return fromJS({ persons: [...arguments], identicalGroups: [] }); }

const MAKE_PERSON_TWIN = 'components/multibirth/MAKE_PERSON_TWIN';
const MAKE_PERSON_SINGLETONE = 'components/multibirth/MAKE_PERSON_SINGLETONE';
const ADD_PERSON_TO_BIRTH_GROUP = 'components/multibirth/ADD_PERSON_TO_BIRTH_GROUP';
const PERSON_CHANGE_GENDER = 'components/multibirth/PERSON_CHANGE_GENDER';
const CHANGE_PERSON_ADOPTION_STATUS = 'components/multibirth/CHANGE_PERSON_ADOPTION_STATUS';
const UPDATE_IDENTICAL_GROUP = 'components/multibirth/UPDATE_IDENTICAL_GROUP';
const REDUCE_PERSON_COUNT_IN_ARRAY = 'components/multibirth/REDUCE_PERSON_COUNT_IN_ARRAY';
const REMOVE_PERSON_FROM_ARRAY = 'components/multibirth/REMOVE_PERSON_FROM_ARRAY';
const UPDATE_DATE_OF_BIRTH = 'components/multibirth/UPDATE_DATE_OF_BIRTH';

const UPDATE_PROBAND_DATE_OF_BIRTH = 'components/multibirth/UPDATE_PROBAND_DATE_OF_BIRTH';
const UPDATE_PROBAND_GENDER = 'components/multibirth/UPDATE_PROBAND_GENDER';

export function defineActionType(action) {
    const TWIN_SWITCH_VARIANTS = { yes: false, no: MAKE_PERSON_SINGLETONE };
    const ADOPTED_SWITCH_VARIANTS = { yes: CHANGE_PERSON_ADOPTION_STATUS, no: false };
    const PROBAND_AFFECT_FIELDS = {
        [DATE_OF_BIRTH_FIELD_NAME]: UPDATE_PROBAND_DATE_OF_BIRTH,
        [GENDER_FIELD_NAME]: UPDATE_PROBAND_GENDER
    };

    const { type, value, name, root } = action;
    const isSetFieldAction = SET_FIELD_VALUE === type;

    const matchPersonsArrayPath = /(multibirth)|(data)|(identicalGroups)/.test(root);
    const matchProbandFields = name in PROBAND_AFFECT_FIELDS;
    if (!matchPersonsArrayPath && !matchProbandFields) { return false; }

    if (!matchPersonsArrayPath && matchProbandFields) { return PROBAND_AFFECT_FIELDS[name]; }

    if (isSetFieldAction) {
        switch (name) {
            case TWIN_FIELD_NAME:               return TWIN_SWITCH_VARIANTS[value];
            case ADOPTED_FIELD_NAME:            return ADOPTED_SWITCH_VARIANTS[value];
            case GENDER_FIELD_NAME:             return PERSON_CHANGE_GENDER;
            case DATE_OF_BIRTH_FIELD_NAME:      return UPDATE_DATE_OF_BIRTH;
            case TWIN_TYPE_FIELD_NAME:          return UPDATE_IDENTICAL_GROUP;
            case PERSON_BIRTH_GROUP_FIELD_NAME: return ADD_PERSON_TO_BIRTH_GROUP;
            default:                            return false;
        }
    }

    if (RESET_FIELD_VALUE === type && /data$/.test(root) && !isNaN(parseInt(name))) { return REMOVE_PERSON_FROM_ARRAY; }

    if (CHANGE_PERSONS_ARRAY === type && 0 < action.difference) { return REDUCE_PERSON_COUNT_IN_ARRAY; }

    return false;
}

function _removeTwinFromMultibirth(multibirths, targetPersonId) {
    const _notMatchId = __makeNotMatchPersonId(targetPersonId);
    let personFound = false;
    return multibirths.map((multibirthGroup) => {
        const persons = multibirthGroup.get(PERSONS_PATH);
        const identicalGroups = multibirthGroup.get(IDENTICAL_GROUPS_PATH);
        const personIdIndex = persons.indexOf(targetPersonId);
        let updatedGroup = multibirthGroup;
        if (-1 !== personIdIndex) {
            if (personFound) {
                console.warn('Inconsistent state detected! removeTwinData: person found in several multibirths');
            } else {
                personFound = true;
            }
            updatedGroup = updatedGroup.set(PERSONS_PATH, persons.remove(personIdIndex));
            if (1 === updatedGroup.get(PERSONS_PATH).size) { return null; }
        }
        const updatedIdenticalGroups = identicalGroups.map((identicalGroup) => {
            const identicalTwinIndex = identicalGroup.indexOf(targetPersonId);
            if ((-1 !== identicalTwinIndex) && (2 === identicalGroup.size)) { return null; }
            return identicalGroup.filter(_notMatchId);
        }).filter(_notANull);
        return updatedGroup.set(IDENTICAL_GROUPS_PATH, updatedIdenticalGroups);
    }).filter(_notANull);
}

export function makePersonSingletone(state, action) {
    const { path, srcPersonId, multibirths } = _extractMultibirthData(state, action);
    const updatedMultibirths = _removeTwinFromMultibirth(multibirths, srcPersonId);
    let _state = state;
    if (PROBAND_INDEX === srcPersonId) { _state = state.set(TWIN_FIELD_NAME, NO_VALUE); }
    return _state.setIn(path, updatedMultibirths);
}

export function makePersonTwin(state, action) {
    const { path, srcPersonId, multibirths } = _extractMultibirthData(state, action);
    const _idMatcher = __makeMatchPersonId(srcPersonId);
    const isRegistered = multibirths.some(
        (multibirthGroup) => {
            const persons = multibirthGroup.get(PERSONS_PATH);
            const identicalGroups = multibirthGroup.get(IDENTICAL_GROUPS_PATH);
            const personRegistered = persons.some(_idMatcher);
            const isIdentical = identicalGroups.some((group) => group.some(_idMatcher));
            if (-1 !== personRegistered) {
                console.warn(`Inconsistent state detected!
                addTwinData: person is found as registered in multibirth while SET_FIELD_VALUE "isTwin"->"yes"`);
            }
            if (-1 === personRegistered && isIdentical) {
                console.warn(`Inconsistent state detected!
                addTwinData: person is not registered in multibirth, but found in identical groups!`);
            }
            return personRegistered || isIdentical;
        }
    );
    let _state = state;
    if (isRegistered) { _state = makePersonSingletone(state, action); }
    const updatedMultibirths = multibirths.push(getDefaultMultibirth(srcPersonId));
    if (PROBAND_INDEX === srcPersonId) { _state.set(TWIN_FIELD_NAME, YES_VALUE); }
    return _state.setIn(path, updatedMultibirths);
}

function _getBirthAndIdenticalGroupEntry(multibirthsList, targetPersonId) {
    const _isIndexOfSrc = __makeIsIndexOf(targetPersonId);
    let targetIdenticalGroupEntry;
    const targetBirthGroupEntry = multibirthsList.findEntry((_birthGroup) => {
        const isTargetBirthGroup = -1 !== _birthGroup.get(PERSONS_PATH).indexOf(targetPersonId);
        if (!isTargetBirthGroup) { return false; }
        targetIdenticalGroupEntry = _birthGroup.get(IDENTICAL_GROUPS_PATH).findEntry(_isIndexOfSrc);
        return true;
    });
    return {
        birthGroupEntry: targetBirthGroupEntry,
        identicalGroupEntry: targetIdenticalGroupEntry
    };
}
export function modifyIdenticalGroup(state, action) {
    const { path, srcPersonId, multibirths } = _extractMultibirthData(state, action);
    const [ dstPersonId, birthType ] = action.value;
    const isIdentical = birthType === IDENTICAL;
    const isFraternal = !isIdentical;
    const _notMatchDst = __makeNotMatchPersonId(dstPersonId);
    //Remove dstPerson from identicalGroup, because now it's not identical
    if (isFraternal) {
        const { birthGroupEntry, identicalGroupEntry } = _getBirthAndIdenticalGroupEntry(multibirths, dstPersonId);
        if (identicalGroupEntry) {
            const [ identicalGroupIndex, identicalGroup ] = identicalGroupEntry;
            const [birthGroupIndex] = birthGroupEntry;
            const updatedIdenticalGroup = identicalGroup.filter(_notMatchDst);
            const pathToIdenticalGroup = [ birthGroupIndex, IDENTICAL_GROUPS_PATH, identicalGroupIndex ];
            let updatedMultibirths;
            if (1 < updatedIdenticalGroup.size) {
                updatedMultibirths = multibirths.setIn(pathToIdenticalGroup, updatedIdenticalGroup);
            } else {
                updatedMultibirths = multibirths.deleteIn(pathToIdenticalGroup);
            }
            return state.setIn(path, updatedMultibirths);
        }
        return state;
    }
    //Trying to add identical twin
    //Check for gender
    const pathToSrcGender = `${action.root} ${GENDER_FIELD_NAME}`;
    const dstIsProband = PROBAND_INDEX === dstPersonId;
    const srcGender = state.getIn(pathToSrcGender.split(SINGLE_SPACE));
    let pathToDstGender;
    if (dstIsProband) {
        pathToDstGender = [GENDER_FIELD_NAME];
    } else {
        pathToDstGender = pathToSrcGender.replace(/\d{1,3} gender$/, `${dstPersonId} ${GENDER_FIELD_NAME}`).split(SINGLE_SPACE);
    }
    const dstGender = state.getIn(pathToDstGender);
    if (dstGender !== srcGender) {
        console.warn(`Siblings with different gender can't be an identical twins`);
        return state;
    }
    //Check for srcPerson and dstPerson identicalGroup
    const { birthGroupEntry: srcBirthGroupEntry, identicalGroupEntry: srcIdenticalGroupEntry } = _getBirthAndIdenticalGroupEntry(multibirths, srcPersonId);
    const { birthGroupEntry: dstBirthGroupEntry, identicalGroupEntry: dstIdenticalGroupEntry } = _getBirthAndIdenticalGroupEntry(multibirths, dstPersonId);
    const srcBirthGroupFound = undefined !== srcBirthGroupEntry;
    const srcIdenticalGroupFound = undefined !== srcIdenticalGroupEntry;
    const dstIdenticalGroupFound = undefined !== dstIdenticalGroupEntry;

    if (!srcBirthGroupFound) {
        console.warn('srcPersonId not found in multibirths');
        return state;
    }

    let updatedMultibirths = multibirths;

    if (srcIdenticalGroupFound) {
        const [ srcBirthGroupIndex, srcBirthGroup ] = srcBirthGroupEntry;
        let [ srcIdenticalGroupIndex, srcIdenticalGroup ] = srcIdenticalGroupEntry;
        updatedMultibirths = _removeTwinFromMultibirth(multibirths, dstPersonId);
        srcIdenticalGroup = srcIdenticalGroup.push(dstPersonId);
        updatedMultibirths = updatedMultibirths.setIn([ srcBirthGroupIndex, PERSONS_PATH ], srcBirthGroup.get(PERSONS_PATH).push(dstPersonId));
        if (undefined === updatedMultibirths.getIn([ srcBirthGroupIndex, IDENTICAL_GROUPS_PATH ])) {
            updatedMultibirths = updatedMultibirths.setIn([ srcBirthGroupIndex, IDENTICAL_GROUPS_PATH ], new List([]));
        }
        updatedMultibirths = updatedMultibirths.setIn([ srcBirthGroupIndex, IDENTICAL_GROUPS_PATH, srcIdenticalGroupIndex ], srcIdenticalGroup);
    }

    if (!srcIdenticalGroupFound && dstIdenticalGroupFound) {
        const [dstBirthGroupIndex] = dstBirthGroupEntry;
        let [ dstIdenticalGroupIndex, dstIdenticalGroup ] = dstIdenticalGroupEntry;
        updatedMultibirths = _removeTwinFromMultibirth(multibirths, srcPersonId);
        dstIdenticalGroup = dstIdenticalGroup.push(srcPersonId);
        updatedMultibirths = updatedMultibirths.setIn([ dstBirthGroupIndex, IDENTICAL_GROUPS_PATH, dstIdenticalGroupIndex ], dstIdenticalGroup);
    }

    if (!srcIdenticalGroupFound && !dstIdenticalGroupFound) {
        const [srcBirthGroupIndex] = srcBirthGroupEntry;
        updatedMultibirths = _removeTwinFromMultibirth(multibirths, dstPersonId);
        let birthGroupPersons, updatedIdenticalGroups;
        if (0 === updatedMultibirths.size) {
            updatedMultibirths = updatedMultibirths.push(getDefaultMultibirth(srcPersonId, dstPersonId));
            birthGroupPersons = updatedMultibirths.getIn([ 0, PERSONS_PATH ]);
            updatedIdenticalGroups = updatedMultibirths.getIn([ 0, IDENTICAL_GROUPS_PATH ]);
        } else {
            birthGroupPersons = updatedMultibirths.getIn([ srcBirthGroupIndex, PERSONS_PATH ]);
            if (birthGroupPersons && birthGroupPersons.toJS) {
                birthGroupPersons = birthGroupPersons.toJS();
            } else {
                birthGroupPersons = [ srcPersonId, dstPersonId ];
            }
            birthGroupPersons = new List(ld.uniq(birthGroupPersons.concat(dstPersonId)));
            updatedIdenticalGroups = updatedMultibirths.getIn([ srcBirthGroupIndex, IDENTICAL_GROUPS_PATH ]);
        }
        if (updatedIdenticalGroups) {
            updatedIdenticalGroups = updatedIdenticalGroups.push(new List([ srcPersonId, dstPersonId ]));
        } else {
            updatedIdenticalGroups = new List([new List([ srcPersonId, dstPersonId ])]);
        }
        updatedMultibirths = updatedMultibirths.setIn([ srcBirthGroupIndex, PERSONS_PATH ], birthGroupPersons);
        updatedMultibirths = updatedMultibirths.setIn([ srcBirthGroupIndex, IDENTICAL_GROUPS_PATH ], updatedIdenticalGroups);
    }

    return state.setIn(path, updatedMultibirths);
}

export function addPersonToBirthGroup(state, action) {
    const { path, srcPersonId, multibirths } = _extractMultibirthData(state, action);
    const [ dstPersonId, isChecked ] = action.value;
    let updatedMultibirths = _removeTwinFromMultibirth(multibirths, dstPersonId);
    if (isChecked) { return state.setIn(path, _removeTwinFromMultibirth(updatedMultibirths, dstPersonId)); }
    let pathToDstTwin = [];
    if (PROBAND_INDEX !== dstPersonId) {
        pathToDstTwin = pathToDstTwin.concat(action.root.replace(/\d{1,3}$/, dstPersonId).split(SINGLE_SPACE));
    }

    /** FILTER HERE ADOPTED PERSONS **/
    const isAdopted = state.getIn(pathToDstTwin.concat(ADOPTED_FIELD_NAME)) === YES_VALUE;
    if (isAdopted) { return state; }

    let updatedState = state.setIn(pathToDstTwin.concat(TWIN_FIELD_NAME), YES_VALUE);

    const srcPersonDob = state.getIn(action.root.split(SINGLE_SPACE).concat(DATE_OF_BIRTH_FIELD_NAME));
    updatedState = updatedState.setIn(pathToDstTwin.concat(DATE_OF_BIRTH_FIELD_NAME), srcPersonDob);

    const { birthGroupEntry } = _getBirthAndIdenticalGroupEntry(updatedMultibirths, srcPersonId);
    if (undefined !== birthGroupEntry) {
        const [ birthGroupIndex, birthGroup ] = birthGroupEntry;
        const updatedPersonsList = birthGroup.get(PERSONS_PATH).push(dstPersonId);
        const updatedBirthGroup = birthGroup.set(PERSONS_PATH, updatedPersonsList);
        updatedMultibirths = updatedMultibirths.set(birthGroupIndex, updatedBirthGroup);
        return updatedState.setIn(path, updatedMultibirths);
    }
    const newBirthGroup = {
        [PERSONS_PATH]: [ srcPersonId, dstPersonId ],
        [IDENTICAL_GROUPS_PATH]: []
    };
    updatedMultibirths = updatedMultibirths.push(fromJS(newBirthGroup));

    return updatedState.setIn(path, updatedMultibirths);
}

export function changePersonGender(state, action) {
    const { path, srcPersonId, multibirths } = _extractMultibirthData(state, action);
    const _mathId = __makeMatchPersonId(srcPersonId);
    let identicalGroupEntry,
        indexOfSrcPersonInIdenticalGroup;
    const birthGroupEntry = multibirths.findEntry((multibirthGroup) => {
        const personRegistered = multibirthGroup.get(PERSONS_PATH).some(_mathId);
        if (personRegistered) {
            identicalGroupEntry = multibirthGroup.get(IDENTICAL_GROUPS_PATH).findEntry((identicalGroup) => {
                const _indexOfSrcPerson = identicalGroup.indexOf(srcPersonId);
                const hasSrcPersonId = -1 !== _indexOfSrcPerson;
                if (hasSrcPersonId) { indexOfSrcPersonInIdenticalGroup = _indexOfSrcPerson; }
                return hasSrcPersonId;
            });
        }
        return personRegistered;
    });
    if (undefined === birthGroupEntry) { return state; }
    const [ groupIndex, group ] = birthGroupEntry;
    if (undefined === identicalGroupEntry) { return state; }
    const [ identicalGroupIndex, identicalGroup ] = identicalGroupEntry;
    let updatedIdenticalGroup, updatedGroup;
    if (2 > identicalGroup.size) {
        updatedIdenticalGroup = identicalGroup.remove(indexOfSrcPersonInIdenticalGroup);
        updatedGroup = group.setIn([ IDENTICAL_GROUPS_PATH, identicalGroupIndex ], updatedIdenticalGroup);
    } else {
        updatedGroup = group.deleteIn([ IDENTICAL_GROUPS_PATH, identicalGroupIndex ]);
    }
    return state.setIn(path.concat(groupIndex), updatedGroup);
}

function _compareNumbers(leftValue, rightValue) { return leftValue - rightValue; }
function _willBeRemoved(keys) { return (key) => -1 !== keys.indexOf(key); }
export function reducePersonsCountInArray(state, action) {
    const { name, gender, difference } = action;

    const personsByGender = state.getIn([ name, DATA_PATH ]).filter((person) => {
        return gender === person.get(GENDER_FIELD_NAME) && YES_VALUE === person.get(TWIN_FIELD_NAME);
    });
    if (0 === personsByGender.size()) { return state; }
    const keysWillBeRemoved = Object.keys(personsByGender.toJS()).sort(_compareNumbers).slice(difference);
    const _isOutdatedKey = _willBeRemoved(keysWillBeRemoved);
    const updatedMultibirhts = state.getIn([ name, MULTIBIRTH_PATH ]).map((multibirthGroup) => {
        const updatedPersons = multibirthGroup.get(PERSONS_PATH).filter(_isOutdatedKey);
        if (0 === updatedPersons.size()) { return null; }
        const updatedIdenticalGroups = multibirthGroup.get(IDENTICAL_GROUPS_PATH).map((identicalGroup) => {
            const updatedGroup = identicalGroup.filter(_isOutdatedKey);
            if (0 === updatedGroup.size()) { return null; }
            return updatedGroup;
        }).filter(_notANull);
        return multibirthGroup.set(PERSONS_PATH, updatedIdenticalGroups);
    }).filter(_notANull);
    return state.setIn([ name, MULTIBIRTH_PATH ], updatedMultibirhts);
}

export function directlyRemovePersonFromArray(state, action) {
    const { name, root } = action;
    const path = root.replace(/data/, MULTIBIRTH_PATH).split(' ');
    const multibirths = state.getIn(path);
    const _notMatchId = __makeNotMatchPersonId(name);
    const updatedMultibirth = multibirths.map((multibirthGroup) => {
        const updatedPersons = multibirthGroup.get(PERSONS_PATH).filter(_notMatchId);
        if (0 === updatedPersons.size) { return null; }
        const identicalGroups = multibirthGroup.get(IDENTICAL_GROUPS_PATH).map((identicalGroup) => {
            const updatedGroup = identicalGroup.filter(_notMatchId);
            if (1 === updatedGroup.size) { return null; }
            return updatedGroup;
        }).filter(_notANull);
        return multibirthGroup.set(PERSONS_PATH, updatedPersons).set(IDENTICAL_GROUPS_PATH, identicalGroups);
    }).filter(_notANull);
    return state.setIn(path, updatedMultibirth);
}


export function changeDateOfBirth(state, action) {
    const { srcPersonId, multibirths } = _extractMultibirthData(state, action);
    const newDoB = action.value;
    const path = action.root.split(SINGLE_SPACE).slice(0, -1); //get all elements, except last one
    let updatedState = state,
        probandIsTwin = false;
    multibirths.forEach((multibirthGroup) => {
        if (-1 === multibirthGroup.get(PERSONS_PATH).indexOf(srcPersonId)) { return; }
        probandIsTwin = probandIsTwin || (-1 !== multibirthGroup.get(PERSONS_PATH).indexOf(PROBAND_INDEX));
        multibirthGroup.get(PERSONS_PATH).forEach((personId) => {
            if (personId === PROBAND_INDEX) { return; }
            updatedState = updatedState.setIn(path.concat(personId, DATE_OF_BIRTH_FIELD_NAME), newDoB);
        });
    });
    if (probandIsTwin) { return updatedState.set(DATE_OF_BIRTH_FIELD_NAME, newDoB); }
    return updatedState;
}


export function probandDateOfBirthUpdate(state, action) {
    const value = action.value;
    const probandBirthGroup = state.getIn([ 'siblings', MULTIBIRTH_PATH ]).find((birthGroup) => {
        return -1 !== birthGroup.get(PERSONS_PATH).indexOf(PROBAND_INDEX);
    });
    let _state = state;
    if (probandBirthGroup) {
        let siblings = state.getIn([ 'siblings', DATA_PATH ]);
        probandBirthGroup.get(PERSONS_PATH).forEach((personId) => {
            if (personId === PROBAND_INDEX) { return; }
            siblings = siblings.setIn([ personId, DATE_OF_BIRTH_FIELD_NAME ], value);
        });
        _state = state.setIn([ 'siblings', DATA_PATH ], siblings);
    }
    return _state;
}


export function probandChangeGender(state, action) {
    if (action.value === state.get(GENDER_FIELD_NAME)) { return state; }
    const multibirth = state.getIn([ 'siblings', MULTIBIRTH_PATH ]);
    const { birthGroupEntry, identicalGroupEntry } = _getBirthAndIdenticalGroupEntry(multibirth, PROBAND_INDEX);
    if (undefined === identicalGroupEntry) { return state; }
    const _notMathProband = __makeNotMatchPersonId(PROBAND_INDEX);
    const [ birthGroupIndex, birthGroup ] = birthGroupEntry;
    const [ identicalGroupIndex, identicalGroup ] = identicalGroupEntry;
    const updatedIdenticalGroup = identicalGroup.filter(_notMathProband);
    const updatedBirthGroup = birthGroup.setIn([ IDENTICAL_GROUPS_PATH, identicalGroupIndex ], updatedIdenticalGroup);
    return state.setIn([ 'siblings', MULTIBIRTH_PATH, birthGroupIndex ], updatedBirthGroup);
}

export function personChangeAdoption(state, action) {
    const { path, srcPersonId, multibirths } = _extractMultibirthData(state, action);
    return state.setIn(path, _removeTwinFromMultibirth(multibirths, srcPersonId));
}

export function twinControlReducer(state, action) {
    const actionType = defineActionType(action);
    switch (actionType) {
        case ADD_PERSON_TO_BIRTH_GROUP:     return addPersonToBirthGroup(...arguments);
        case MAKE_PERSON_TWIN:              return makePersonTwin(...arguments);
        case UPDATE_IDENTICAL_GROUP:        return modifyIdenticalGroup(...arguments);
        case MAKE_PERSON_SINGLETONE:        return makePersonSingletone(...arguments);
        case REDUCE_PERSON_COUNT_IN_ARRAY:  return reducePersonsCountInArray(...arguments);
        case CHANGE_PERSON_ADOPTION_STATUS: return personChangeAdoption(...arguments);
        case PERSON_CHANGE_GENDER:          return changePersonGender(...arguments);
        case UPDATE_PROBAND_GENDER:         return probandChangeGender(...arguments);
        case REMOVE_PERSON_FROM_ARRAY:      return directlyRemovePersonFromArray(...arguments);
        case UPDATE_DATE_OF_BIRTH:          return changeDateOfBirth(...arguments);
        case UPDATE_PROBAND_DATE_OF_BIRTH:  return probandDateOfBirthUpdate(...arguments);
        default:                            return state;
    }
}
